'use client';

import { queryClient } from '@/utils/query-client';
import { QueryClientProvider } from '@tanstack/react-query';


export default function QueryClientWrapper({children}) {
    return <QueryClientProvider client={queryClient}>
        {children}
    </QueryClientProvider>
}